/*
 * 将一个数组分成几个同等长度的数组
 * array[分割的原数组]
 * size[每个子数组的长度]
 */
export function sliceArray(array, size) {
  let arr2=[];
  for(let i=0;i<array.length;i=i+size){
    arr2.push(array.slice(i,i+size));
  }
  return arr2;
  // let result = [];
  // for (let x = 0; x < Math.ceil(array.length / size); x++) {
  //   let start = x * size;
  //   let end = start + size;
  //   result.push(array.slice(start, end));
  // }
  // return result;
}

export function maopao(arra) {
  let temp;

  for (let i = 0; i < arra.length; i++) {
    //比较多少趟，从第一趟开始

    for (let j = 0; j < arra.length - i - 1; j++) {
      //每一趟比较多少次数
      if (arra[j] > arra[j + 1]) {
        temp = arra[j];
        arra[j] = arra[j + 1];
        arra[j + 1] = temp;
      }
    }
  }
  return arra;
}

export function  groupBy(array, f) {
  const groups = {};
  array.forEach(function (o) {
    const group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export  function arrayUniq(array){
  let temp = []; //一个新的临时数组
  for(let i = 0; i < array.length; i++){
    if(temp.indexOf(array[i]) == -1){
      temp.push(array[i]);
    }
  }
  return temp;
}

export  function jsonToFormData(params) {
  if(params==undefined){
    return "";
  }
  let result="";
  Object.keys(params).forEach((key,i,array) => {
    let value=params[key];
    if(value===undefined || value===null || value===""){
      return;
    }
    result=result+key+"="+params[key];
    if((array.length-1)!=i){
      result=result+"&"
    }
  });

  return result;


}


export function randomExtend (minNum, maxNum) {
  if (arguments.length === 1) {
    return parseInt(Math.random() * minNum + 1, 10)
  } else {
    return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
  }
}

export function debounce (delay, callback) {
  let lastTime

  return function () {
    clearTimeout(lastTime)

    const [that, args] = [this, arguments]

    lastTime = setTimeout(() => {
      callback.apply(that, args)
    }, delay)
  }
}

export function observerDomResize (dom, callback) {
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver

  const observer = new MutationObserver(callback)

  observer.observe(dom, { attributes: true, attributeFilter: ['style'], attributeOldValue: true })

  return observer
}

export function getPointDistance (pointOne, pointTwo) {
  const minusX = Math.abs(pointOne[0] - pointTwo[0])

  const minusY = Math.abs(pointOne[1] - pointTwo[1])

  return Math.sqrt(minusX * minusX + minusY * minusY)
}
// 判断是否是全屏
export function isFullScreen () {
  return (document.body.scrollHeight == window.screen.height && document.body.scrollWidth == window.screen.width);
}



export function colorRgba (sHex, alpha = 1) {
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //  处理六位的颜色值
    var sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    // 或
    return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
  } else {
    return sColor
  }
}


function geMobile(tel){
  let reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, "$1****$2");
}



// WEBPACK FOOTER //
// ./src/utils/index.js